// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import * as React from "react";
import { loadArchivedChunk } from "../vendor/runtime.js";
import { archivedNamespace } from "../vendor/runtime.js";
function LottieAnimation({
  src: src,
  className: className,
  loop: o = true,
  autoplay: a = true,
  playOnHover: r = false,
  playOnVisible: l = false,
  assetsPath: assetsPath,
}) {
  let c = (0, React.useRef)(null),
    d = (0, React.useRef)(null),
    u = (0, React.useRef)(false),
    p = (0, React.useRef)(false),
    m = (0, React.useRef)(false),
    g = (0, React.useCallback)(() => {
      let e = d.current;
      if (!e) {
        p.current = true;
        return;
      }
      u.current || ((u.current = true), e.goToAndPlay(0, true));
    }, []);
  return (
    (0, React.useEffect)(() => {
      let t = c.current;
      if (!t) return;
      let n = "/",
        m = false,
        h = null;
      return (
        (async () => {
          try {
            let { default: c } = await loadArchivedChunk(3008).then(
              archivedNamespace.bind(null, 11635, 23),
            );
            if (m) return;
            let f = await fetch(`${n}${src}`),
              M = await f.json();
            if (m) return;
            t.replaceChildren();
            let y = r || l;
            ((d.current = h =
              c.loadAnimation({
                container: t,
                renderer: "svg",
                loop: !y && o,
                autoplay: !y && a,
                animationData: M,
                assetsPath: assetsPath ? `${n}${assetsPath}` : undefined,
              })),
              y &&
                (h.addEventListener("complete", () => {
                  u.current = false;
                }),
                p.current ? ((p.current = false), g()) : l || g()));
          } catch (t) {
            console.error("[LottieJson] load failed", src, t);
          }
        })(),
        () => {
          ((m = true),
            (d.current = null),
            (u.current = false),
            (p.current = false),
            h?.destroy(),
            t.replaceChildren());
        }
      );
    }, [src, o, a, r, l, assetsPath, g]),
    (0, React.useEffect)(() => {
      if (!l) return;
      let e = c.current;
      if (!e) return;
      m.current = false;
      let t = new IntersectionObserver(
        ([e]) => {
          if (e.intersectionRatio < 0.5) {
            m.current = false;
            return;
          }
          m.current || ((m.current = true), g());
        },
        {
          threshold: [0, 0.5],
        },
      );
      return (
        t.observe(e),
        () => {
          ((m.current = false), t.disconnect());
        }
      );
    }, [l, g]),
    (
      <div
        ref={c}
        className={className}
        aria-hidden={true}
        onMouseEnter={r ? g : undefined}
      />
    )
  );
}
export { LottieAnimation };
